import React from 'react';
import TimeRangePicker from 'client/js/util/time_range_picker';
import PropTypes from 'prop-types';

const PhpErrorLogFilters = ({ filters, onFilterChange, filterErrors }) => {
  const handleTimeRangeChange = (timeRange) => {
    if (timeRange) {
      onFilterChange('from_time', timeRange.from_time);
      onFilterChange('to_time', timeRange.to_time);
    } else {
      onFilterChange('from_time', '');
      onFilterChange('to_time', '');
    }
  };

  const getCurrentTimeRangeValue = () => {
    if (filters.from_time && filters.to_time) {
      return `${filters.from_time}|${filters.to_time}`;
    }
    return '';
  };

  return (
    <>
      <div className="filter-group">
        <label>Script-Pfad:</label>
        <input
          type="text"
          className={`form-control form-control-sm ${filterErrors.script ? 'is-invalid' : ''}`}
          value={filters.script || ''}
          onChange={(e) => onFilterChange('script', e.target.value)}
          placeholder="z.B. /index.php, /wp-content"
        />
        {filterErrors.script && <div className="invalid-feedback">{filterErrors.script}</div>}
      </div>

      <div className="filter-group">
        <label>Error Level:</label>
        <select
          className={`form-control form-control-sm ${filterErrors.level ? 'is-invalid' : ''}`}
          value={filters.level || ''}
          onChange={(e) => onFilterChange('level', e.target.value)}
        >
          <option value="">Alle Level</option>
          <option value="deprecated">Deprecated</option>
          <option value="notice">Notice</option>
          <option value="info">Info</option>
          <option value="warning">Warning</option>
          <option value="error">Error</option>
          <option value="fatal_error">Fatal Error</option>
          <option value="parse_error">Parse Error</option>
        </select>
        {filterErrors.level && <div className="invalid-feedback">{filterErrors.level}</div>}
      </div>

      <div className="filter-group">
        <label>Nachricht:</label>
        <input
          type="text"
          className={`form-control form-control-sm ${filterErrors.message ? 'is-invalid' : ''}`}
          value={filters.message || ''}
          onChange={(e) => onFilterChange('message', e.target.value)}
          placeholder="Teiltext der Fehlermeldung"
        />
        {filterErrors.message && <div className="invalid-feedback">{filterErrors.message}</div>}
      </div>

      <div className="filter-group">
        <label>Zeit:</label>
        <TimeRangePicker
          value={getCurrentTimeRangeValue()}
          onChange={handleTimeRangeChange}
          error={filterErrors.from_time || filterErrors.to_time}
          maxDays={1}
        />
        {(filterErrors.from_time || filterErrors.to_time) && (
          <div className="invalid-feedback d-block">
            {filterErrors.from_time || filterErrors.to_time}
          </div>
        )}
      </div>
    </>
  );
};

PhpErrorLogFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filterErrors: PropTypes.object.isRequired
};

export default PhpErrorLogFilters;
